import * as Yup from 'yup';

export const createWebhookSchema = Yup.object().shape({
  name: Yup.string().required('Por favor, preencha o campo nome'),
  product: Yup.number().required(),
  url: Yup.string().url('Por favor, insira uma URL válida').required('Por favor, preencha o campo URL'),
});
